import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';

import { SharedModule } from '@shared/shared.module';
import { SellRoutingModule } from './sell.routing';

import { SellComponent } from './pages/sell/sell.component';
import { VerifyAddressComponent } from './pages/sell/verify-address/verify-address.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from '../../../environments/environment';
import { RecaptchaService } from '@core/services/recaptcha.service';

@NgModule({
  declarations: [SellComponent, VerifyAddressComponent],
  imports: [
    CommonModule,
    SharedModule,
    SellRoutingModule,
    FormsModule,
    MatMenuModule,
    MatSelectModule,
    RecaptchaV3Module,
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaKey,
    },
    RecaptchaService,
  ],
})
export class SellModule {}
